import { useEffect, useState } from "react";
import { Link, useParams } from "react-router";
import { Icon } from "../../components/ui/Icon";
import { failing, shownState, type Connection, type ConnectionKind } from "../../lib/connectionsApi";
import { goalsApi } from "../../lib/goalsApi";
import { useConnections } from "./useConnections";

/** The connections of the goal on screen (its product's), for the channel cards. */
export function useGoalConnections() {
  const { goalId = "" } = useParams();
  const [productId, setProductId] = useState<string | null>(null);
  useEffect(() => {
    if (!goalId) return;
    // Why: a goal's setup carries no product; the goal itself names it.
    goalsApi.get(goalId).then(
      (v) => setProductId(v.goal.productId),
      () => setProductId(null),
    );
  }, [goalId]);
  const { conns } = useConnections(productId);
  return { productId, conns };
}

/** A channel card's connection, as the prototype's `chCx` shows it: connected, checking, to fix, or Connect provider. */
export function ChannelPill({ kind, connected, cx }: { kind: ConnectionKind; connected: string; cx: { productId: string | null; conns: Connection[] | null } }) {
  if (!cx.productId || !cx.conns) return null;
  const c = cx.conns.find((x) => x.kind === kind);
  const st = shownState(c);
  const to = `/connections?product=${encodeURIComponent(cx.productId)}`;
  if (st === "ok" || st === "warming") return <span className="pill good">{connected}</span>;
  if (st === "checking") return <span className="pill live">Checking</span>;
  if (st === "fix") {
    const n = Math.max(1, failing(c?.checks ?? []).length);
    return (
      <>
        <span className="pill tight">
          {n} {n === 1 ? "thing" : "things"} to fix
        </span>
        <Link className="btn sm ghost" to={to}>
          Fix it
        </Link>
      </>
    );
  }
  return (
    <Link className="btn sm" to={to}>
      Connect provider
      <Icon name="right" />
    </Link>
  );
}
